import { Routes, Route } from "react-router-dom";
import { Shell } from "./components/shell";
import { HomePage } from "./pages/home";
import { QuickstartPage } from "./pages/quickstart";
import { PlaygroundPage } from "./pages/playground";
import { NotFoundPage } from "./pages/not-found";

export function App() {
  return (
    <Shell>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/quickstart/typescript" element={<QuickstartPage lang="typescript" />} />
        <Route path="/quickstart/python" element={<QuickstartPage lang="python" />} />
        <Route path="/playground" element={<PlaygroundPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Shell>
  );
}
